import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import './App.css';
import futura from './assets/futura.png';

import {
    CardElement,
    Elements, useElements, useStripe
} from '@stripe/react-stripe-js';

const CheckoutForm = (props) => {
    const stripe = useStripe();
    const elements = useElements();
    const [paying, setPaying] = useState(false);

    const appearance = {
        theme: 'night',
     
      };
  
    const handleSubmit = async (event) => {
        event.preventDefault();
        setPaying(true)
        if (elements === null) {
            return;
        }
        const { error, paymentMethod } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
             

        });
        fetch(document.apiURL + '/stripe/preauthPay', {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "bookID": props.bookid,
                "amount": props.amount,
                "currency": 'eur',
                "paymentMethodId": paymentMethod.id
            })
        })
            .then(response => response.json())
            .then(response => {
                stripe.confirmCardPayment(response.clientSecret, {
                    payment_method: {
                        
                        card: elements.getElement(CardElement),
                        billing_details: {
                            name: props.name,
                        },
                    },
                })
                    .then(function (result) {
                       
                        setPaying(false)
                        props.nextPage()
                    });
              
            });
    };

 

    return (
        <form style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems:'center', paddingTop:'15px' }} onSubmit={handleSubmit}>
            <div style={{width:'80%' ,paddingBottom:'15px'}}>
            <CardElement options={{ 
                    style: { 
                        base: {  
                            iconColor: '#1B8FCD',
                            color: '#1B8FCD',
                            fontWeight: '500',
                            colorBackground: '#f1f1f1',
                            fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                            fontSize: '16px',
                            fontSmoothing: 'antialiased',
                            textAlign: 'center',
                            borderRadius: '4px',
                            ':-webkit-autofill': {
                                color: '#fce883',
                            },
                            '::placeholder': {
                                color: '#87BBFD',
                            },
                        },
                        invalid: {
                            iconColor: 'red',
                            color: 'red',
                        },
                    },  
            }} />  </div>
            {!paying ?
                <button className="button margin-top-min" type="submit" disabled={!stripe || !elements}>Paga ora</button> :
                <button className="button margin-top-min" type="submit" disabled={true}>Attendere prego...</button>
            }
        </form>
    );
};

function StripeForm({ nextPage, bookid }) {
    const history = useHistory();
    const [pKey, setPKey] = useState()
    const [book, setBook] = useState([])
    const [amount, setAmount] = useState()
    const [stripeObject, setStripeObject] = useState(null);
    const [name, setName] = useState()

    const getKey = () => {
        fetch(document.apiURL + '/stripe/getPkey', {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
                setPKey(response.publicKey)
                const fetchStripeObject = async () => {
                    // If there is no accountId, do not run the loadStripe function.
                    const res = await loadStripe(response.publicKey);
                    // When we have got the Stripe object, pass it into our useState.
                    setStripeObject(res);
                }
                fetchStripeObject();
                 
            })
    };


    const getBook = () => {
        fetch(document.apiURL + '/book/' + bookid, {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => response.json())
            .then(response => {
            
                if (response[0].hasOwnProperty("treatment")) {
                    if (response[0].treatment !== undefined && response[0].treatment.hasOwnProperty("rate") && response[0].treatment.rate > 0) {
                        setAmount(response[0].treatment.rate)
                    } else {
                        nextPage()
                    }
                    setName(`${response[0]?.patient?.lastname} ${response[0]?.patient?.firstname}`)
                } else {
                    nextPage()
                }
            });
    }

    useEffect(() => {
        getKey();
        getBook();
    }, []);



    return (
        <>
            <div className="back-profilazione" style={{ display: 'flex', flexDirection: 'column' }}>
                <div className="square-center" >
                    <div className="flex row center-con sp">
                        <h2 className="c">Pre-autorizzazione pagamento prestazione</h2><img src={futura} className="min-fut">
                        </img>
                    </div>
                    <div className="input-center" style={{ marginTop: '10px' }}>
                        <div className="col" style={{ width: '80%' }}>
                            <h2 style={{ marginBottom: '5px', marginTop: '5px' }}> {amount}€</h2>
                            <p style={{ marginBottom: '5px', marginTop: '5px' }}>Sulla tua carta verrà addebitato un addebito in sospeso di {amount}€.</p>
                            {/*
                            <input type="text" className="input" style={{ width: '100%', marginTop: '10px' }} placeholder="Nome"></input>
                            <input type="text" className="input card-img" style={{ width: '100%', marginTop: '10px' }} placeholder="Numero carta"></input>
                            */}
                        </div>
                    </div>
                    {!stripeObject ?
                        <span>Loading...</span>
                        : <Elements stripe={stripeObject} >
                            <CheckoutForm bookid={bookid} amount={amount} name={name} nextPage={nextPage} />
                        </Elements>}
                    {/*<div className="input-center" style={{ marginTop: '10px' }}>
                        <div className="col" style={{ width: '80%' }}>
                            <button onClick={() => preauthPay()} className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Continua</button>
                        </div>
                    </div>
                    <button onClick={(a) => } className="button margin-top-min" style={{ marginTop: '20px', width: '50%', alignSelf: 'center' }}>Printa</button>
                    */}
                </div>
                <p style={{ marginTop: '40px', fontWeight: 300, marginBottom: '40px', textAlign: 'center' }}>In caso di necessit&agrave; puoi contattare un nostro operatore al numero<br /> <a href='tel:+3908119312726'>081 193 12 726</a> che ti aiutera nella prenotazione.</p>
            </div>
        </>
    );
}

export default StripeForm;
